import { Link } from '@inertiajs/react'
import { MimirRune } from '@/components/ui/MimirRune'

export function Footer() {
  return (
    <footer className="border-t border-line-soft">
      <div
        className="max-w-5xl mx-auto px-4 sm:px-8 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5 flex-wrap"
        style={{ paddingBottom: 'max(2rem, env(safe-area-inset-bottom))' }}
      >
        <Link
          href="/"
          className="flex items-center gap-3 text-footer-text hover:text-body transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded"
        >
          <MimirRune />
          <span className="font-serif text-xl font-medium">Mímir</span>
        </Link>

        <nav aria-label="Footer navigation" className="flex flex-wrap gap-x-6 gap-y-2">
          <Link
            href="/#languages"
            className="inline-flex items-center min-h-11 font-mono text-xs uppercase tracking-widest text-footer-text hover:text-body transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded"
          >
            Languages
          </Link>
          <Link
            href="/about"
            className="inline-flex items-center min-h-11 font-mono text-xs uppercase tracking-widest text-footer-text hover:text-body transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded"
          >
            About
          </Link>
          <a
            href="#"
            className="inline-flex items-center min-h-11 font-mono text-xs uppercase tracking-widest text-footer-text hover:text-body transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded"
          >
            Privacy
          </a>
          <a
            href="mailto:hello@mimirlang.eu"
            className="inline-flex items-center min-h-11 font-mono text-xs uppercase tracking-widest text-footer-text hover:text-body transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded"
          >
            Contact
          </a>
        </nav>

        <span className="font-mono text-xs uppercase tracking-widest text-footer-text">
          Made in Europe
        </span>
      </div>
    </footer>
  )
}
